import { findIndex } from "lodash"

const templateState = {
  id: -1,
  type: "",
  concentration: 0,
  description: "",
  held: false,
  onShelf: true,
  inScene: true,
};

export default (state = templateState, action) => {
  let currentRotorAdapter;
  let currentRotorAdapters;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_ROTOR_ADAPTERS" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
          if(state.protocolSection.scene.apparatus.hasOwnProperty("rotorAdapters")){
            currentRotorAdapter = state.protocolSection.scene.apparatus.rotorAdapters[findIndex(state.protocolSection.scene.apparatus.rotorAdapters, { id: action.payload.id })]
          }
      }
  }

  switch (action.type) {
    case 'CREATE_ROTOR_ADAPTERS':

      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props }

      if(protocolSection.scene.apparatus.hasOwnProperty("rotorAdapters")){
        protocolSection.scene.apparatus.rotorAdapters = [ ...protocolSection.scene.apparatus.rotorAdapters, newObj ]
      } else {
        protocolSection.scene.apparatus.rotorAdapters = [newObj]
      }

      return { ...state, ...{
        protocolSection: protocolSection
      } }

      case "SET_ROTOR_ADAPTERS_IN_SCENE":
        //Payload = {inScene}
        currentRotorAdapter.inScene = action.payload.inScene;
        protocolSection.scene.apparatus.rotorAdapters[findIndex(state.protocolSection.scene.apparatus.rotorAdapters, { id: action.payload.id })] = currentRotorAdapter;
        return { ...state, ...{ protocolSection: protocolSection } };

      case "SET_ROTOR_ADAPTERS_ON_SHELF":
        //Payload = {onShelf}
        currentRotorAdapter.onShelf = action.payload.onShelf;
        protocolSection.scene.apparatus.rotorAdapters[findIndex(state.protocolSection.scene.apparatus.rotorAdapters, { id: action.payload.id })] = currentRotorAdapter;
        return { ...state, ...{ protocolSection: protocolSection } };

      case "SET_ROTOR_ADAPTERS_HELD":
        currentRotorAdapter.held = action.payload.held;
        protocolSection.scene.apparatus.rotorAdapters[findIndex(state.protocolSection.scene.apparatus.rotorAdapters, { id: action.payload.id })] = currentRotorAdapter;
        return { ...state, ...{ protocolSection: protocolSection } };


      case "SET_ROTOR_ADAPTERS_CONTROLS_VISIBLE":
        // Hide the controls for all the other pipettes
        // state.gels.forEach(gel => {
        //   gel.controlsVisible = false;
        // });
        // Make the current gels controls visible
        currentRotorAdapters = state.protocolSection.scene.apparatus.rotorAdapters;
        currentRotorAdapters.forEach(gel => {
          gel.controlsVisible = false;
        });
        protocolSection.scene.apparatus.rotorAdapters = currentRotorAdapters

        currentRotorAdapter.controlsVisible = action.payload.controlsVisible;

        protocolSection.scene.apparatus.rotorAdapters[findIndex(state.gels, { id: action.payload.id })] = currentRotorAdapter;
        return { ...state, ...{ protocolSection: protocolSection } };

      case "HIDE_ALL_CONTROLS":
        // Hide the controls for all the other pipettes
        if(!protocolSection.scene.apparatus.hasOwnProperty("rotorAdapters")){
          return { ...state, ...{
            protocolSection: protocolSection
          } }
        }
        currentRotorAdapters = state.protocolSection.scene.apparatus.rotorAdapters;
        currentRotorAdapters.forEach(gel => {
          gel.controlsVisible = false;
        });
        protocolSection.scene.apparatus.rotorAdapters = currentRotorAdapters

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      // case "UNDO":
      //   //Payload = {lastState}
      //   if (action.payload.lastState !== null  && protocolSection.scene.apparatus.hasOwnProperty('rotorAdapters')) {
      //
      //     protocolSection.scene.apparatus.rotorAdapters = action.payload.lastState.scene.apparatus.rotorAdapters
      //
      //     return { ...state, ...{
      //       protocolSection: protocolSection
      //     } }
      //
      //   } else {
      //     return state;
      //   }

      default:
        return state;
    }
  };
